import { withChildren } from '@builder.io/react';
import { HeroVariant } from '../../../global/types';
import { withTracking } from '../../../observability';
import {
  CtaGoal,
  CtaName,
  SectionName,
} from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../builder';
import { imgElement } from '../../../builder/element-factories';
import { HeroSection } from './HeroSection';
import { COLOR_KEYS, ICON_NAMES } from '../../../constants';

export default createBuilderModule(
  withChildren(
    withTracking(HeroSection, { sectionName: SectionName.HeroSection }),
  ),
  {
    name: 'HeroSection',
    image: 'https://cdn.zappy.app/b131ef7a291b8a1a46b47e432e98dd4b.png',
    defaultChildren: [
      imgElement({
        src: 'https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png',
      }),
    ],
    inputs: [
      {
        name: 'variant',
        type: 'string',
        defaultValue: HeroVariant.standard,
        enum: [
          HeroVariant.standard,
          HeroVariant.colorBlock,
          HeroVariant.features,
        ],
      },
      {
        name: 'heading',
        type: 'string',
        defaultValue: 'Example Heading',
        required: true,
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        defaultValue: COLOR_KEYS.neutral100,
        required: true,
      },
      {
        name: 'ctaText',
        type: 'string',
        defaultValue: 'Sign up',
      },
      {
        name: 'ctaName',
        type: 'string',
        enum: Object.values(CtaName),
        defaultValue: CtaName.signup,
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
      },
      {
        name: 'ctaGoal',
        type: 'string',
        enum: Object.values(CtaGoal),
        defaultValue: CtaGoal.signup,
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
      },
      {
        name: 'ctaHref',
        type: 'string',
        defaultValue: '#',
      },
      {
        name: 'ctaDisclaimer',
        type: 'richText',
        defaultValue:
          'By signing up, you agree to Zapier’s <a href="https://zapier.com/legal" target="_blank">Terms of Service</a> and <a href="https://zapier.com/privacy" target="_blank">Privacy Policy</a>',
      },
      {
        name: 'openInNewTab',
        helperText: 'Controls whether or not the CTA link opens in a new tab',
        type: 'boolean',
      },
      {
        name: 'ctaColor',
        type: 'string',
        enum: ['primary', 'primary-alt', 'primary-dark', 'brand'],
      },
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'labelIcon',
        type: 'string',
        enum: Object.values(ICON_NAMES),
      },
      {
        name: 'labelColor',
        type: 'string',
        enum: [
          'info',
          'success',
          'error',
          'warning',
          'white',
          'gray',
          'peach',
          'neutral300',
          'bolt',
          'cream',
        ],
      },
    ],
  },
);
